import { render } from "./InnerTable.vue?vue&type=template&id=99eb65ba&scoped=true"
import script from "./InnerTable.vue?vue&type=script&lang=js"
export * from "./InnerTable.vue?vue&type=script&lang=js"

import "./InnerTable.vue?vue&type=style&index=0&id=99eb65ba&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99eb65ba"]])

export default __exports__